(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-product-classic"]) return;
  try {
    
  const initializedClassicWidgets = new WeakSet();

  function selectClassicOneTimePurchase() {
    const widgets = document.querySelectorAll('.ProductForm__ClassicPurchaseOptions .sealsubs-target-element');

    for (const widget of widgets) {
      if (initializedClassicWidgets.has(widget)) continue;

      const oneTimeOption = widget.querySelector('input[type="radio"][value="one_time"]');
      if (!oneTimeOption || oneTimeOption.disabled) continue;

      // Apply the default once so later customer selections remain intact.
      initializedClassicWidgets.add(widget);
      widget.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
        detail: { selling_plan_id: '' }
      }));
    }
  }

  function scheduleClassicOneTimePurchase() {
    // Let Seal finish setting its initial selling plan and price first.
    window.setTimeout(selectClassicOneTimePurchase, 0);
  }

  document.addEventListener('sealsubs:subscription_widget_created', scheduleClassicOneTimePurchase);
  document.addEventListener('shopify:section:load', scheduleClassicOneTimePurchase);
  scheduleClassicOneTimePurchase();

  } catch(e) { console.error(e); }
})();
})();
